import { ReactElement } from 'react';

import { DONUT_OTHER_COLOR } from '../../../config';
import {
  Legend,
  LegendItem,
  LegendLabel,
  LegendSwatch,
} from '../styles';
import { ChartDatum } from '../types';

interface DonutLegendProps {
  data: ChartDatum[];
  colors: string[];
  hidden: Set<string>;
  onToggle: (name: string) => void;
}

export function DonutLegend({
  data,
  colors,
  hidden,
  onToggle,
}: Readonly<DonutLegendProps>): ReactElement {
  return (
    <Legend>
      {data.map((item, idx) => {
        const isHidden = hidden.has(item.name);
        return (
          <LegendItem
            type="button"
            key={`${item.name}-${idx.toString()}`}
            $disabled={isHidden}
            onClick={() => onToggle(item.name)}
          >
            <LegendSwatch $color={isHidden ? DONUT_OTHER_COLOR : colors[idx]} />
            <LegendLabel $disabled={isHidden} title={item.name}>
              {item.name}
            </LegendLabel>
          </LegendItem>
        );
      })}
    </Legend>
  );
}
